<template>
  <div>
    <div class="pg-wrapper">
      <app-header>
        <div class="pg-title-block mb50" slot="header-foot">
          <div class="container is-fluid">
            <h1 class="title">My Preferences Survey</h1>
          </div>
        </div>
      </app-header>
      <main> 
        <relationship v-if="step == 1"></relationship>
        <gender v-else-if="step == 2"></gender>
        <type v-else-if="step == 3"></type>
        <feel v-else-if="step == 4"></feel>
        <product-kind v-else-if="step == 5"></product-kind>
        <flavours v-else-if="step == 6"></flavours>
        <time-period v-else-if="step == 7"></time-period>
      </main>
      <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Relationship from '@/Components/Pages/User/Survey/Relationship';
import Gender from '@/Components/Pages/User/Survey/Gender';
import Type from '@/Components/Pages/User/Survey/Type';
import Feel from '@/Components/Pages/User/Survey/Feel';
import ProductKind from '@/Components/Pages/User/Survey/ProductKind';
import Flavours from '@/Components/Pages/User/Survey/Flavours';
import TimePeriod from '@/Components/Pages/User/Survey/TimePeriod';

export default {
  components: {
    Relationship,
    Gender,
    Type,
    Feel,
    ProductKind,
    Flavours,
    TimePeriod,
  },
  data() {
    return {
 
    };
  },
  computed: {
    ...mapGetters({
      step: "usersurvey/step"
    })
  },
  mounted() {
    this.va_setSurveyEmpty();
    this.va_setStep(1);
  },
  methods: {
    ...mapActions({
      va_setStep: "usersurvey/setStep",
      va_setSurveyEmpty: "usersurvey/setSurveyEmpty"
    })
  },
};
</script>